export default __webpack_public_path__ + "static/media/mumbai2.8c93f6e2.jpg";